import type { HttpErrorShape } from "@kalodata/http";
import type { ClipHttpContext, ClipHttpMeta } from "./types";
import { isNil, isNotNil } from "@kalodata/tools";

const HTTP_ERROR_TOAST_SHOWN = Symbol.for("clip.http.error.toastShown");

export type ClipHttpError = HttpErrorShape<unknown, ClipHttpMeta, ClipHttpContext> & {
  [HTTP_ERROR_TOAST_SHOWN]?: true;
};

export function markHttpErrorToastShown(error: unknown): void {
  if (isNotNil(error) && typeof error === "object") {
    (error as ClipHttpError)[HTTP_ERROR_TOAST_SHOWN] = true;
  }
}

export function isHttpErrorToastShown(error: unknown): boolean {
  if (isNil(error) || typeof error !== "object") return false;
  if ((error as ClipHttpError)[HTTP_ERROR_TOAST_SHOWN]) return true;
  return false;
}
